/* eslint-disable react/prop-types */
import React from 'react';
import { ConfirmationModal, Spinner } from '@crc-evans/ui-components';
import ProductivitySummaryBadges from './ProductivitySummaryBadges';
import './DprSubmitReviewModal.css';

const ReadOnlyField = ({ label, value, multiline = false }) => (
  <div className="dpr-submit-review-field">
    <span className="dpr-submit-review-field__label">{label}</span>
    {multiline ? (
      <div className="dpr-submit-review-field__textarea">{value || '—'}</div>
    ) : (
      <div className="dpr-submit-review-field__value">{value || '—'}</div>
    )}
  </div>
);

const DprSubmitReviewModal = ({
  isOpen,
  isLoading = false,
  isSubmitting = false,
  isOffshore = false,
  ongoingPipelineLabel = '',
  productivityRows = [],
  remarks = '',
  managerName = '',
  clientName = '',
  approverName = '',
  crceNameLabel = 'Manager Name',
  clientNameLabel = 'Client Name',
  showApproverField = true,
  onConfirm,
  onCancel,
}) => (
  <ConfirmationModal
    title="Submit DPR"
    message={(
      <div className="dpr-submit-review">
        <p className="dpr-submit-review__intro">
          Are you sure you want to submit? Please review the productivity section and comments below before confirming.
        </p>

        {isOffshore && ongoingPipelineLabel ? (
          <section className="dpr-submit-review-section">
            <h4 className="dpr-submit-review-section__title">Ongoing pipeline</h4>
            <ReadOnlyField label="Selected pipeline" value={ongoingPipelineLabel} />
          </section>
        ) : null}

        <section className="dpr-submit-review-section">
          <h4 className="dpr-submit-review-section__title">Productivity</h4>
          {isLoading ? (
            <div className="dpr-submit-review-loading" role="status" aria-live="polite">
              <Spinner variant="inline" size="small" />
              <span>Loading productivity summary…</span>
            </div>
          ) : productivityRows.length === 0 ? (
            <p className="dpr-submit-review-empty">No productivity data available for this shift.</p>
          ) : (
            <div className="dpr-submit-review-productivity-list">
              {productivityRows.map((row) => (
                <div key={row.id ?? row.label} className="dpr-submit-review-mainline">
                  <div className="dpr-submit-review-mainline__title">{row.label}</div>
                  <ProductivitySummaryBadges
                    summary={row}
                    isLoading={false}
                    className="dpr-submit-review-productivity-chips"
                    variant={isOffshore ? 'offshore' : 'onshore'}
                  />
                </div>
              ))}
            </div>
          )}
        </section>

        <section className="dpr-submit-review-section">
          <h4 className="dpr-submit-review-section__title">Comments</h4>
          <ReadOnlyField label="Notes / Remarks" value={remarks} multiline />
          <div className="dpr-submit-review-names">
            <ReadOnlyField label={crceNameLabel} value={managerName} />
            <ReadOnlyField label={clientNameLabel} value={clientName} />
            {showApproverField ? (
              <ReadOnlyField label="Approver Name" value={approverName} />
            ) : null}
          </div>
        </section>
      </div>
    )}
    confirmText={isSubmitting ? 'Submitting…' : 'Submit'}
    cancelText="Cancel"
    isOpen={isOpen}
    onConfirm={onConfirm}
    onCancel={onCancel}
    size="large"
    confirmButtonProps={{
      disabled: isLoading || isSubmitting,
      style: {
        backgroundColor: '#991B1B',
        borderColor: '#991B1B',
      },
    }}
  />
);

export default DprSubmitReviewModal;
